import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-transaction-date-change-history',
  templateUrl: './transaction-date-change-history.component.html',
  styleUrls: ['./transaction-date-change-history.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TransactionDateChangeHistoryComponent implements OnInit {

  @Input() history: [];
  
  @Output() closed: EventEmitter<void> = new EventEmitter();


  constructor() { }

  ngOnInit(): void {
  }


}
